import { Box, IconButton, Typography } from '@material-ui/core'
import { IBoxImage } from 'interfaces/IDashboard'
import { ILoadingConference } from 'interfaces/ILoadingConference'
import { useRef, useState } from 'react'
import { LuImageOff } from 'react-icons/lu'
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md'
import Slider from 'react-slick'

import ModalInfo from './ModalInfo'
import { IOverlayRef, Overlay } from './Overlay'
import { useStyles } from './styles'

interface IProps {
  boxesImage: IBoxImage[]
  loadingData: Partial<ILoadingConference>
}

export const Boxes = (props: IProps) => {
  const { boxesImage, loadingData } = props
  const sliderRef = useRef<Slider>(null)
  const overlayRef = useRef<IOverlayRef>(null)
  const classes = useStyles()
  const boxImageQuantity = boxesImage.length
  const [openModal, setOpenModal] = useState(false)

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 150,
    slidesToShow: boxImageQuantity >= 3 ? 3 : boxImageQuantity,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: boxImageQuantity >= 2 ? 2 : boxImageQuantity,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const next = () => {
    sliderRef.current?.slickNext()
  }
  const previous = () => {
    sliderRef.current?.slickPrev()
  }

  const data = boxesImage.sort(
    (prev, next) => new Date(prev.created).getTime() - new Date(next.created).getTime(),
  )

  const renderContent = () => {
    if (boxImageQuantity > 0) {
      return (
        <Slider {...settings} ref={sliderRef}>
          {data.map((box, index) => (
            <Box className={classes.container} key={box.id}>
              <Box className={classes.box}>
                <Box mb="1rem" p="0 0.5rem">
                  <Typography className={classes.boxTitle}>QRCODE: {box.tag_value}</Typography>
                  <Typography className={classes.boxSubtitle}>
                    {new Date(box.created).toLocaleString()}
                  </Typography>
                </Box>
                {box.url_image?.includes('Falha') || !box.url_image ? (
                  <Box
                    position="relative"
                    borderRadius="1rem"
                    width="100%"
                    pt="62.305%"
                    bgcolor="#dadada"
                  >
                    <Box className={classes.boxError}>
                      <LuImageOff size={40} color="#b4b4b4" />
                      <Typography style={{ textAlign: 'center', color: '#7e7e7e' }}>
                        Falha na comunicação com o serviço de imagens
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <img src={box.url_image} onClick={() => overlayRef.current?.handleOpen(index)} />
                )}
              </Box>
            </Box>
          ))}
        </Slider>
      )
    } else if (boxImageQuantity === 0) {
      return (
        <Box className={classes.container}>
          <Box className={classes.box}>
            <Box mb="1rem" p="0 0.5rem">
              <Typography className={classes.boxTitle}>Pedido sem fotos</Typography>
            </Box>
            <Box
              position="relative"
              borderRadius="1rem"
              width="100%"
              pt="62.305%"
              bgcolor="#dadada"
            >
              <Box className={classes.boxError}>
                <LuImageOff size={30} color="#b4b4b4" />
                <Typography style={{ textAlign: 'center', color: '#7e7e7e', fontSize: '0.9rem' }}>
                  Não há imagens disponíveis para este pedido
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )
    } else {
      return null
    }
  }

  return (
    <>
      <Box m="2rem 0">
        <Box component="header" display="flex" justifyContent="space-between" mb="1rem">
          <Box>
            <Typography component="h2" className={classes.title}>
              Caixas
            </Typography>
            {loadingData && (
              <button onClick={() => setOpenModal(true)} className={classes.infoButton}>
                Ver contagem
              </button>
            )}
          </Box>
          {boxImageQuantity > 0 && (
            <Box>
              <IconButton onClick={previous}>
                <MdOutlineKeyboardArrowLeft />
              </IconButton>
              <IconButton onClick={next}>
                <MdOutlineKeyboardArrowRight />
              </IconButton>
            </Box>
          )}
        </Box>

        {renderContent()}
      </Box>

      <Overlay ref={overlayRef} boxes={data} />
      <ModalInfo
        open={openModal}
        onClose={() => setOpenModal(false)}
        loadingData={loadingData || {}}
        boxImageQuantity={boxImageQuantity}
      />
    </>
  )
}
